module.exports = __webpack_public_path__ + "static/img/3.c7d0fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/3.png
// module id = 8BJC
// module chunks = 0